module.exports = __webpack_public_path__ + "img/qrcode.33b1ea39.png";